
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-channels",
      function () {
        return require("private-next-pages/payment-channels/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment-channels"])
      });
    }
  